import { GridDefault, GridStudio, CategoryGrid } from '../models/grid.models';

export const InitialGridDefault: GridDefault = {
    currentPage: 0,
    pageProductIds: [],
    totalPagesIds: 0,
    idsFiltered: [],
    productsFullyLoaded: false,
};

export const InitialGridStudio: GridStudio = {
    currentPage: 0,
    pageGridElements: [],
    totalPagesGridElements: 0,
    gridElementsFiltered: [],
};

export const InitialCategoryGrid: CategoryGrid = {
    gridDefault: InitialGridDefault,
    gridStudio: InitialGridStudio,
    gridNewCollection: null,
    totalQuantityProducts: null,
    categoryId: null,
};
